import { ajaxCart } from './ajax-cart'

export const updateCart = ($form, widget, href) => {
  if (href === undefined) {
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      data: $form.serialize(),
      success: function (result) {
        ajaxCart(widget)
      },
      error: function (error) {
        alert(error.responseJSON.description)
      }
    })
  } else {
    $.post('/cart/update.js', 'updates[' + href + ']=0').done(function () {
      ajaxCart(widget)
    })
  }
}
